__turbopack_context__.v({
  "loader": "Loader-module-scss-module__poq8oq__loader",
  "loader-blink": "Loader-module-scss-module__poq8oq__loader-blink",
});
